/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { grayScale, textFontSize } from 'components/styles';

const style = css({
  border: `solid 1px ${grayScale.gray10}`,
  boxSizing: 'border-box',
  borderRadius: '4px',
  width: '100%',
  fontSize: textFontSize.re,
  padding: '8px',
  paddingRight: '36px',
  marginTop: '4px',
  // Edgeの標準パスワード表示ボタンが目玉アイコンと重なるため非表示にする
  '&::-ms-reveal': {
    display: 'none',
  },
});

const PasswordInput: React.FC<{
  name: string;
  label: string;
  value: string;
  visible?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}> = ({
  name, value, onChange,onKeyPress, visible = false
}) => (
  <input
    css={style}
    id={name}
    name={name}
    type={visible ? 'text' : 'password'}
    value={value}
    onChange={onChange}
    onKeyPress={onKeyPress}

  />
);

export default PasswordInput;
